export default __webpack_public_path__ + "static/media/tictactoe-desktop.bd571faf.png";